import snackbar from './snackbar';

// rtkQueryErrorLogger only toasts responses that carry `data.message`; a dropped connection has
// no response, so the auth forms surface it here instead of leaving an unhandled rejection.
const handleSubmitError = (error: { status?: unknown }) => {
  if (error?.status === 'FETCH_ERROR') {
    snackbar.error(
      'ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی کنید و دوباره تلاش کنید.'
    );
  }
};

export default handleSubmitError;
